import { takeLatest, call, put, all } from 'redux-saga/effects'
import { signInSuccess, signFailure, refreshTokenSuccess } from './actions'

import { ecommerceApi, learningApi } from '../../../services/api'
import history from '../../../services/history'
import { SignInPayload, AuthTypes } from './types'
import { Action } from 'redux'
import { toast } from 'react-toastify'
import { SubscriptionTypes } from '../subscription/types'
import { LearningCoursesTypes } from '../learningCourses/types'
import { PosthogActions } from '../posthog/types'
import { StudyPlanActionTypes } from '../studyPlan/types'
import { TimerActionTypes } from '../timer/types'
import posthog from 'posthog-js'

interface SignInAction extends Action, SignInPayload {
  type: AuthTypes.SIGN_IN_REQUEST
}

interface RefreshTokenAction extends Action, SignInPayload {
  type: AuthTypes.REFRESH_TOKEN_REQUEST
}

export function* signIn(data: any): any {
  try {
    const path = window.location.pathname
    const payload = {
      ...data.payload,
      platform: 'areaAluno',
    }
    const response = yield call(learningApi.post, '/student/auth', payload)

    const { token, refresh_token, student, subscription, preference } = response.data

    learningApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
    ecommerceApi.defaults.headers.common['Authorization'] = `Bearer ${token}`

    localStorage.setItem('token', token)

    yield put(
      signInSuccess({
        token,
        refresh_token,
        profile: {
          ...student,
          subscription,
          preference: preference[0]?.objectType,
          tracked: false,
        },
      })
    )

    if (path === '/') return history.push('/home')

    return history.push(path)
  } catch (err) {
    console.error(err)
    yield put(signFailure())

    if (!err.response) {
      return toast.error('Erro inesperado. Tente novamente mais tarde.')
    }

    if (err.response.data.error === 'User not found') {
      return toast.error('Usuário não encontrado')
    }

    if (err.response.data.error === 'Invalid Password') {
      return toast.error('Senha inválida')
    }

    return toast.error('Algo deu errado, verifique suas credenciais e tente novamente')
  }
}

export function setToken(payload: any): any {
  if (!payload) return

  // if (payload) return api.defaults.headers.common['Authorization'] = `Bearer ${payload.payload.auth.token}`
}

export function* signOut(): any {
  // Limpa todos os dados sensíveis do usuário para evitar vazamento entre sessões
  yield put({ type: SubscriptionTypes.CLEAR_SUBSCRIPTIONS })
  yield put({ type: LearningCoursesTypes.CLEAR_COURSES })
  yield put({ type: PosthogActions.CLEAR_FEATURE_FLAGS })
  yield put({ type: StudyPlanActionTypes.CLEAR_STUDY_PLAN })
  yield put({ type: TimerActionTypes.RESET_TIMER })

  // Limpa o token do localStorage
  localStorage.removeItem('token')

  // Reseta o PostHog para evitar tracking entre usuários
  posthog.reset()

  // Limpa o cookie de refresh token
  document.cookie = '@DireçãoConcursos_refresh_token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT'

  history.push('/')
}

export function* refreshToken(data: any): any {
  try {
    const payload = {
      ...data.payload,
      platform: 'areaAluno',
    }

    const response = yield call(ecommerceApi.post, 'student/auth/token/refresh', payload)

    const { token, refresh_token } = response.data

    ecommerceApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
    learningApi.defaults.headers.common['Authorization'] = `Bearer ${token}`

    localStorage.setItem('token', token)

    yield put(refreshTokenSuccess({ token, refresh_token }))
  } catch (error) {
    yield put({ type: '@auth/SIGN_OUT' })
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest<SignInAction>(AuthTypes.SIGN_IN_REQUEST, signIn),
  takeLatest<RefreshTokenAction>(AuthTypes.REFRESH_TOKEN_REQUEST, refreshToken),
  takeLatest('@auth/SIGN_OUT', signOut),
])
